export const TERM_SHEET_DISCLAIMER =
  "This term sheet contains indicative terms and conditions for a secured term loan facilities (the Facilities) to be arranged by the Arranger (as defined below). It does not constitute an offer, undertaking or legally binding commitment to arrange or to provide any financing but contains the terms upon which we are willing to progress the preparation of a credit application. The provision of the Facilities and any commitment by the Lender is subject to, inter alia, market conditions, the granting of all relevant investment committee approvals and the completion of due diligence and legal documentation to our satisfaction. All numbers set out herein are subject to further diligence and review.";

export const TERM_SHEET_FONT_FAMILY = '"Times New Roman", Times, serif';

/** Matches the closing disclaimer body text in the preview panel. */
export const TERM_SHEET_PREVIEW_TEXT_SX = {
  fontFamily: TERM_SHEET_FONT_FAMILY,
  fontSize: "11pt",
  lineHeight: 1.35,
  color: "#000000",
} as const;

export const TERM_SHEET_PREVIEW_SX = {
  ...TERM_SHEET_PREVIEW_TEXT_SX,
  bgcolor: "#ffffff",
} as const;
